const win = window,
    doc = document;
let karmads = win.karmads || {};
karmads.vars = karmads.vars || {};
